import React from "react";
import { Collapse, Checkbox } from "@mantine/core";
import LeftSummaryWidget from "./LeftSummaryWidget";
import TemperatureSummary from "../../../Establishment/Establishments/Summary/Widgets/TemperatureSummary";
import DissolvedOxygenSummary from "../../../Establishment/Establishments/Summary/Widgets/DissolvedOxygenSummary";
import OxygenSaturationSummary from "../../../Establishment/Establishments/Summary/Widgets/OxygenSaturationSummary";
import SalinitySummary from "../../../Establishment/Establishments/Summary/Widgets/SalinitySummary";
import SemaforoFallas from "./SemaforoFallas";
import AlertasWidget from "./AlertasWidget";

const MemoizedWidget = React.memo(
    ({
        WidgetComponent,
        title,
        um,
        code_siep,
        height,
        showHeader,
        showFooter,
        icon,
        h100,
    }) => (
        <WidgetComponent
            title={title}
            um={um}
            code_siep={code_siep}
            height={height}
            showHeader={showHeader}
            showFooter={showFooter}
            icon={icon}
            h100={h100}
        />
    )
);

const LeftPanel = ({
    showLeftPanel,
    leftPanelSection,
    selectedEstablishment,
    isLoadingEstablishments,
    searchParams,
    codeSiep,
    activeTab,
    setActiveTab,
    LAYER_OPTIONS,
    MAPBOX_STYLES,
    selectedMapStyle,
    setSelectedMapStyle,
    showLayerFilter,
    setShowLayerFilter,
    selectedLayers,
    setSelectedLayers,
}) => {
    return (
        <section className="scrollable-section">
            {showLeftPanel && (
                <Collapse in={leftPanelSection === "widgets"} transitionDuration={0}>
                    <div className="left-panel-widgets w-widgets">
                        <div className="left-panel-header">
                            <div className="establishment-info-container">
                                <h2 className="left-panel-title">
                                    {isLoadingEstablishments ? (
                                        <span className="placeholder-glow">
                                            <span className="placeholder col-8"></span>
                                        </span>
                                    ) : (
                                        selectedEstablishment?.nombre_centro || selectedEstablishment?.nombre ||
                                        "Seleccione un establecimiento"
                                    )}
                                </h2>

                                <div className="establishment-footer">
                                    <div className="establishment-subtitle fs-12">
                                        <div>
                                            <i className="ri-map-pin-line me-2"></i>
                                            <span>
                                                {selectedEstablishment?.region_centro ||
                                                    "Región no especificada"}
                                            </span>
                                        </div>
                                        <div className="code-item fs-12">
                                            <i className="ri-price-tag-3-line me-1"></i>
                                            <span>{selectedEstablishment?.siep_code || "N/A"}</span>
                                        </div>
                                    </div>

                                    <div className="establishment-codes">
                                        <div>
                                            <i className="ri-fingerprint-line me-1"></i>
                                            <span>
                                                {selectedEstablishment?._id
                                                    ? String(selectedEstablishment._id)
                                                        .slice(-8)
                                                        .toUpperCase()
                                                    : "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid-layout-3x3">
                            <div className="grid-item grid-row-1 grid-col-1-3 ">
                                <LeftSummaryWidget code_siep={codeSiep} />
                            </div>
                            <div className="grid-item grid-row-2-3 grid-col-1-3 left-panel-widgets-graphics rounded-4">
                                <div className="custom-tabs-nav">
                                    <button
                                        className={`custom-tab ${activeTab === "graficos" ? "active" : ""
                                            }`}
                                        onClick={() => setActiveTab("graficos")}
                                        style={{
                                            backgroundColor:
                                                activeTab === "graficos"
                                                    ? "rgba(255, 255, 255, 0.9)"
                                                    : "transparent",
                                            color:
                                                activeTab === "graficos"
                                                    ? "#000"
                                                    : "rgba(0, 0, 0, 0.6)",
                                            borderRadius:
                                                activeTab === "graficos" ? "0.3rem 0.3rem 0 0" : "0",
                                        }}
                                        onMouseEnter={(e) => {
                                            if (activeTab !== "graficos") {
                                                e.target.style.backgroundColor =
                                                    "rgba(255, 255, 255, 0.5)";
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (activeTab !== "graficos") {
                                                e.target.style.backgroundColor = "transparent";
                                            }
                                        }}
                                    >
                                        <i className="ri-line-chart-line me-1"></i>
                                        Gráficos
                                    </button>
                                    {/* <button
                                        className={`custom-tab ${activeTab === "alertas" ? "active" : ""
                                            }`}
                                        onClick={() => setActiveTab("alertas")}
                                        style={{
                                            backgroundColor:
                                                activeTab === "alertas"
                                                    ? "rgba(255, 255, 255, 0.9)"
                                                    : "transparent",
                                            color:
                                                activeTab === "alertas" ? "#000" : "rgba(0, 0, 0, 0.6)",
                                            borderRadius:
                                                activeTab === "alertas" ? "0.3rem 0.3rem 0 0" : "0",
                                        }}
                                        onMouseEnter={(e) => {
                                            if (activeTab !== "alertas") {
                                                e.target.style.backgroundColor =
                                                    "rgba(255, 255, 255, 0.5)";
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (activeTab !== "alertas") {
                                                e.target.style.backgroundColor = "transparent";
                                            }
                                        }}
                                    >
                                        <i className="ri-alert-line me-1"></i>
                                        Alertas
                                    </button> */}
                                </div>

                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "calc(100% - 40px)",
                                    }}
                                >
                                    {activeTab === "graficos" && (
                                        <div
                                            style={{
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <MemoizedWidget
                                                WidgetComponent={DissolvedOxygenSummary}
                                                title="Oxígeno"
                                                um="mg/L"
                                                code_siep={codeSiep}
                                                height={180}
                                                showFooter={false}
                                            />
                                            <MemoizedWidget
                                                WidgetComponent={OxygenSaturationSummary}
                                                title="Saturación"
                                                um="%"
                                                code_siep={codeSiep}
                                                height={180}
                                                showFooter={false}
                                            />
                                            <MemoizedWidget
                                                WidgetComponent={TemperatureSummary}
                                                title="Temperatura"
                                                um="°C"
                                                code_siep={codeSiep}
                                                height={180}
                                                showFooter={false}
                                            />
                                            <MemoizedWidget
                                                WidgetComponent={SalinitySummary}
                                                title="Salinidad"
                                                um="psu"
                                                code_siep={codeSiep}
                                                height={180}
                                                showFooter={false}
                                            />
                                        </div>
                                    )}

                                    {activeTab === "alertas" && (
                                        <div
                                            style={{
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                                padding: "8px",
                                            }}
                                        >
                                            <div style={{ flex: "1" }}>
                                                <SemaforoFallas />
                                            </div>
                                            <div style={{ flex: "1" }}>
                                                <AlertasWidget />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            )}
            <Collapse in={leftPanelSection === "styles"} transitionDuration={0}>
                <div className="left-panel-widgets">
                    <div className="mapbox-styles">
                        {MAPBOX_STYLES.map((style) => (
                            <button
                                key={style.key}
                                onClick={() => setSelectedMapStyle(style.style)}
                                style={{
                                    border:
                                        selectedMapStyle === style.style
                                            ? "1.5px solid #0D1C36"
                                            : "1px solid #e0e0e0",
                                    boxShadow:
                                        selectedMapStyle === style.style
                                            ? "0 0 8px #0D1C3633"
                                            : "0 1px 4px #0001",
                                }}
                            >
                                <img src={style.icon} alt={style.label} />
                                <span>{style.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </Collapse>
            <Collapse in={showLayerFilter} transitionDuration={0}>
                <div className='left-panel-widgets rounded-4 layerFilter'>
                    <div className="rounded-4">
                        <span className="fw-bolder">Capas a mostrar</span>
                        <div className="d-flex flex-column gap-2 mt-2">
                            {LAYER_OPTIONS.map(layer => (
                                <div
                                    key={layer.value}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const isCurrentlySelected = selectedLayers.includes(layer.value);
                                        if (isCurrentlySelected) {
                                            setSelectedLayers(prev => prev.filter(l => l !== layer.value));
                                        } else {
                                            setSelectedLayers(prev => [...prev, layer.value]);
                                        }
                                    }}
                                >
                                    <Checkbox
                                        label={layer.label}
                                        checked={selectedLayers.includes(layer.value)}
                                        onChange={() => { }} 
                                        style={{ cursor: 'pointer', pointerEvents: 'none' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Collapse>
        </section>
    );
};

export default LeftPanel;
